import { render } from "./NavSidebarTooltip.vue?vue&type=template&id=e57dfab6&scoped=true"
import script from "./NavSidebarTooltip.vue?vue&type=script&lang=js"
export * from "./NavSidebarTooltip.vue?vue&type=script&lang=js"

import "./NavSidebarTooltip.vue?vue&type=style&index=0&id=e57dfab6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e57dfab6"

export default script